export default function PlatformOperations() {
  return (<>
      <section className="section-space dashboard-section">
        <div className="container dashboard-grid">
          <div className="dashboard-copy reveal">
            <div className="eyebrow">{"CONTROL CENTER"}</div>
            <h2>{"One control center for your digital operations."}</h2>
            <p>{"See services, support, infrastructure, payments, customers and business applications from one place."}</p>
            <ul className="check-list">
              <li>{"Unified service visibility"}</li>
              <li>{"Cross-module reporting"}</li>
              <li>{"Role-based team access"}</li>
              <li>{"Audit-friendly activity history"}</li>
            </ul>
            <a href="#contact" className="btn btn-dark">{"Request a Demo"}</a>
          </div>

          <div className="dashboard-mock reveal delay-1">
            <aside className="dash-side">
              <div className="dash-logo">{"OS"}</div>
              <span className="active">{"Overview"}</span><span>{"Services"}</span><span>{"Projects"}</span><span>{"Infrastructure"}</span><span>{"QA"}</span><span>{"Security"}</span><span>{"Payments"}</span><span>{"CRM"}</span><span>{"WhatsApp"}</span><span>{"Bookings"}</span><span>{"Orders"}</span><span>{"Reports"}</span>
            </aside>
            <div className="dash-main">
              <div className="dash-top">
                <div><small>{"Workspace"}</small><strong>{"Global Operations"}</strong></div>
                <div className="avatar">{"MA"}</div>
              </div>
              <div className="metric-grid">
                <div className="metric"><small>{"Services Active"}</small><strong>{"7"}</strong><em>{"+2 this month"}</em></div>
                <div className="metric"><small>{"Open Requests"}</small><strong>{"3"}</strong><em>{"1 urgent"}</em></div>
                <div className="metric"><small>{"System Health"}</small><strong>{"99.98%"}</strong><em>{"All systems normal"}</em></div>
                <div className="metric"><small>{"Transactions"}</small><strong>{"18,420"}</strong><em>{"Demo data"}</em></div>
              </div>
              <div className="chart-card">
                <div className="chart-head"><div><small>{"Activity"}</small><strong>{"Platform usage"}</strong></div><span>{"Last 7 days"}</span></div>
                <div className="bar-chart">
                  <i style={{"height": "32%"}}></i><i style={{"height": "55%"}}></i><i style={{"height": "44%"}}></i><i style={{"height": "72%"}}></i><i style={{"height": "68%"}}></i><i style={{"height": "88%"}}></i><i style={{"height": "76%"}}></i><i style={{"height": "93%"}}></i><i style={{"height": "81%"}}></i><i style={{"height": "98%"}}></i>
                </div>
              </div>
              <div className="dash-bottom-grid">
                <div className="mini-panel"><small>{"Reconciliation"}</small><strong>{"99.7%"}</strong><span>{"Matched automatically"}</span></div>
                <div className="mini-panel"><small>{"WhatsApp"}</small><strong>{"3,840"}</strong><span>{"Conversations"}</span></div>
                <div className="mini-panel"><small>{"Orders"}</small><strong>{"1,287"}</strong><span>{"Processed"}</span></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-space process-section">
        <div className="container">
          <div className="section-heading centered reveal">
            <div className="eyebrow">{"HOW IT WORKS"}</div>
            <h2>{"From requirement to operation in one platform."}</h2>
          </div>
          <div className="process-grid">
            <div className="process-step reveal"><span>{"01"}</span><h3>{"Pick"}</h3><p>{"Choose the software or managed services you need."}</p></div>
            <div className="process-arrow">{"→"}</div>
            <div className="process-step reveal delay-1"><span>{"02"}</span><h3>{"Configure"}</h3><p>{"Tell us your country, business and requirements."}</p></div>
            <div className="process-arrow">{"→"}</div>
            <div className="process-step reveal delay-2"><span>{"03"}</span><h3>{"Launch"}</h3><p>{"Connect apps, APIs and business channels."}</p></div>
            <div className="process-arrow">{"→"}</div>
            <div className="process-step reveal delay-3"><span>{"04"}</span><h3>{"Manage"}</h3><p>{"Operate it yourself or let our experts run it."}</p></div>
          </div>
        </div>
      </section>

      <section className="section-space payments-section" id="payments">
        <div className="container payments-grid">
          <div className="payments-copy reveal">
            <div className="eyebrow">{"PAYMENTS"}</div>
            <h2>{"Connect your business to payments."}</h2>
            <p>{"Integrate payment infrastructure appropriate for your market without managing every integration yourself."}</p>
            <div className="payment-list">
              <div><span>{"01"}</span><b>{"Payment Integration"}</b><small>{"Connect supported gateways, acquirers and payment providers."}</small></div>
              <div><span>{"02"}</span><b>{"P2M QR"}</b><small>{"Enable supported merchant QR acceptance."}</small></div>
              <div><span>{"03"}</span><b>{"Hosted Checkout"}</b><small>{"Redirect customers to a managed checkout experience."}</small></div>
              <div><span>{"04"}</span><b>{"Bill Collections"}</b><small>{"Generate, collect, track and reconcile payments."}</small></div>
              <div><span>{"05"}</span><b>{"Reconciliation"}</b><small>{"Match transactions, settlements and internal records."}</small></div>
            </div>
          </div>

          <div className="payments-visual reveal delay-1">
            <div className="flow-card input-card">
              <small>{"YOUR BUSINESS"}</small>
              <strong>{"Single Integration Layer"}</strong>
            </div>
            <div className="flow-line"></div>
            <div className="payment-hub">
              <span className="pulse"></span>
              <strong>{"PAYMENT"}<br />{"ORCHESTRATION"}</strong>
            </div>
            <div className="provider-grid">
              <div>{"Gateway"}</div><div>{"QR"}</div><div>{"Bank"}</div><div>{"Wallet"}</div><div>{"Bill Pay"}</div><div>{"Checkout"}</div>
            </div>
            <div className="flow-note">{"One integration layer. Multiple payment possibilities."}</div>
          </div>
        </div>

        <div className="container regulatory-note">{"\n          Payment and collection capabilities are provided directly where authorized and/or through licensed payment partners.\n          Availability, payment methods and commercial terms vary by country.\n        "}</div>
      </section>

  </>);
}
